module.exports = __webpack_public_path__ + "img/med0002.debb4600.png";